import React from "react";
import { useParams } from "react-router-dom";

import ExecutiveEducationSectionNav from "./ExecutiveEducationSectionNav";
import TopSection from "./components/TopSection";


import AIR from "./components/advanced-international-relations/AIR";
import EJ from "./components/emerging-journalist/EJ";
import EP from "./components/emerging-politician/EP";
import YEE from "./components/young-emerging-enterpreneur/YEE";
import YEI from "./components/young-emerging-international-relations/YEI";
import YTS from "./components/young-trade-specialist/yts";

const topSectionData = {
  "advanced-international-relations": {
    title: "Advanced International Relations & Diplomatic Practice Course",
    selectedImage:
      "/image-fix/random-images/advanced-international-relations.jpg",
    credits: "60 ECTS",
    duration: "3 to 6 Months",
    cost: "€850",
  },
  "emerging-journalist": {
    title: "The Emerging Journalist Program",
    selectedImage: "/image-fix/random-images/emerging-journalist.jpg",
    credits: "30 ECTS",
    duration: "3 to 6 Months",
    cost: "€650",
  },

  "emerging-politician": {
    title: "The Young Emerging Politician Program",
    selectedImage: "/image-fix/random-images/young-emerging-politician.jpg",
    credits: "30 ECTS",
    duration: "3 to 6 Months",
    cost: "€650",
  },
  "young-emerging-entrepreneur": {
    title: "The Young Emerging Entrepreneur Program",
    selectedImage: "/image-fix/random-images/young-emerging-entepreneur.jpg",
    credits: "15 ECTS",
    duration: "10 weeks (part-time)",
    cost: "$350",
  },
  "young-emerging-international-relations": {
    title: "The Young Emerging International Relations & Diplomatic Practice",
    selectedImage:
      "/image-fix/random-images/international-relations-diplomat.jpg",
    credits: "30 ECTS",
    duration: "3 to 6 Months",
    cost: "€850",
  },
  "young-trade-specialist": {
    title: "The Young Trade Specialist Programme",
    selectedImage: "/image-fix/random-images/young-trade-specialist.jpg",
    credits: "15 ECTS",
    duration: "10 weeks (part-time)",
    cost: "$350",
  },
};

const componentMap = {
  "advanced-international-relations": AIR,
  "emerging-journalist": EJ,
  "emerging-politician": EP,
  "young-emerging-entrepreneur": YEE,
  "young-emerging-international-relations": YEI,
  "young-trade-specialist": YTS,
};

const ExecutiveEducationTemplate = () => {
  const { courseId } = useParams(); 

  const currentTopSectionData = topSectionData[courseId];

  const SelectedComponent = componentMap[courseId];

  const handleNavClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <div>
        <TopSection courseData={currentTopSectionData} />
      </div>

      <div className="flex max-w-7xl mx-auto">
        <div className="w-1/4 pr-4 hidden md:block">
          <ExecutiveEducationSectionNav onNavClick={handleNavClick} />
        </div>
        <div className="md:w-3/4 px-4 py-2 overflow-y-auto">
          {SelectedComponent ? (
            <SelectedComponent />
          ) : (
            <p>Course not found. Please select a valid course.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExecutiveEducationTemplate;
